import * as React from 'react'

export function FormSection({
  title,
  children,
  className,
}: {
  readonly title: string
  readonly children: React.ReactNode
  readonly className?: string
}): JSX.Element {
  return (
    <section className={className ?? 'mb-8'}>
      <div className="mb-4 border-b border-borderGrey pb-2">
        <h2 className="text-base font-semibold text-primaryTextColor">{title}</h2>
      </div>
      {children}
    </section>
  )
}
